// extracted by mini-css-extract-plugin
export default {"closeBtnContainer":"MultiFormAntecedentes_closeBtnContainer__SB41n"};